import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

// This component handles the "Reset" logic for Tiptap HTML
const RichTextContent = styled(Typography)(({ theme }) => ({
  color: "#444",
  fontSize: "1rem",
  
  // Default margins
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(4),
  
  // Target raw HTML tags injected via dangerous HTML
  "& p": {
    margin: 0,
    marginBottom: "1em",
    lineHeight: 1.6,
  },
  "& strong, & b": {
    fontWeight: 700,
  },
  "& em, & i": {
    fontStyle: "italic",
  },
  "& ul, & ol": {
    paddingLeft: "2rem",
    marginBottom: "1em",
  },
  "& li": {
    marginBottom: "0.5em",
  },
  "& h1, & h2, & h3, & h4, & h5, & h6": {
    fontWeight: 700,
    marginTop: "1em",
    marginBottom: "0.5em",
    color: "#0a1a3b", 
  },
  "& a": {
    color: "#00b5e2",
    textDecoration: "underline",
  },
  whiteSpace: "pre-line",
}));

export default RichTextContent;